import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import AppContainer from '../../../../components/AppContainer';
import PBIcon from '../../../../components/PBIcon';
import RecordBinderCard from '../../../../components/RecordBinderCard';
import NoRecordsFound from '../../../../components/NoRecordsFound';
import { showErrorAlert } from '../../../../components/Alerts';
import withRouter from '../../../../routes/withRouter';

import localization from '@progressivebeef/shared/src/localization/i18n';
import { getLocale } from '@progressivebeef/shared/src/services/storageService/GlobalData';
import RouteConstants from '@progressivebeef/shared/src/constants/RouteConstants';
import { ERROR_SCREEN_TYPES } from '@progressivebeef/shared/src/constants/AppConstants';
import {
  getBinRecordBindersRequest,
  searchBinRecordBinders,
  resetRecordBinderBinProps,
} from '@progressivebeef/shared/src/store/actions/recordBinder';
import AssetConstants from '@progressivebeef/shared/src/constants/AssetConstants';
import '../style.scss';

class RecordBinderBin extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sort: false,
    };
  }
  componentDidMount() {
    this.props.getBinRecordBinders({ update: false });
  }

  onCardPress = (item) => {
    const { history } = this.props;
    history.push(RouteConstants.RECORD_BINDER_DETAIL, {
      currentRecordBinder: item,
    });
  };

  onSearchPress = (query) => {
    this.props.searchBinRecordBinders(query);
    this.props.getBinRecordBinders({ update: false });
  };

  onRefresh = () => {
    if (navigator.onLine) {
      this.props.getBinRecordBinders({ update: true });
    } else {
      showErrorAlert(localization[getLocale()].OFFLINE_MODE_REFRESH_ERROR);
    }
  };

  sortPress = () => {
    const { sort } = this.state;
    this.props.getBinRecordBinders({ sort: !sort, update: false });
    this.setState({ sort: !sort });
  };

  renderLeftHeader = () => {
    const { sort } = this.state;

    return (
      <div
        className="head-icon left-align"
        style={{ display: 'flex', alignItems: 'center' }}>
        <PBIcon
          name={'chevron-left'}
          onPress={() => this.props.history.goBack()}
        />
        <div
          onClick={() => this.sortPress()}
          className="feedyard-head-icon left-align"
          style={{ marginLeft: 12, cursor: 'pointer' }}>
          {sort ? (
            <img alt="description" src={AssetConstants.timeSort} />
          ) : (
            <PBIcon name={'sort-alpha-up'} />
          )}
        </div>
      </div>
    );
  };

  render() {
    const { history, query, binRecords, error } = this.props;
    const hasBinRecords = binRecords && binRecords.length > 0;
    const isNoInternet = !navigator.onLine && !hasBinRecords;
    const isServerError =
      !isNoInternet &&
      error &&
      Object.keys(error).length !== 0 &&
      !hasBinRecords;

    const screenType = isNoInternet
      ? ERROR_SCREEN_TYPES.NETWORK_ERROR
      : isServerError
      ? ERROR_SCREEN_TYPES.SERVER_ERROR
      : ERROR_SCREEN_TYPES.NO_RECORDS;

    return (
      <AppContainer
        title={localization[getLocale()].RECORDS_BIN || 'Bin'}
        searchText={query || ''}
        onSearchPress={this.onSearchPress}
        iconHeader
        noncollapsible
        IconLeftHeader={this.renderLeftHeader}
        history={history}
      >
        <div className="record-binder-container">
          {hasBinRecords ? (
            binRecords.map((item, index) => (
              <RecordBinderCard
                key={`${item.record_binder_id}-${index}`}
                item={item}
                onCardPress={this.onCardPress}
              />
            ))
          ) : (
            <div className="no-records-result-found">
              <NoRecordsFound screenType={screenType} onButtonPress={this.onRefresh} />
            </div>
          )}
        </div>
      </AppContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  binRecords: state.recordBinder.binRecordBinders,
  query: state.recordBinder.binQuery,
  error: state.recordBinder.binError,
});

const mapDispatchToProps = {
  getBinRecordBinders: getBinRecordBindersRequest,
  searchBinRecordBinders,
  resetRecordBinderBinProps,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(RecordBinderBin));


